
  export default {
    data() {
      return {
        testimonialImages: [
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_1_name',
                image: require("../assets/images/testimonial-images/25.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_2_name',
                image: require("../assets/images/testimonial-images/26.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_3_name',
                image: require("../assets/images/testimonial-images/27.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_4_name',
                image: require("../assets/images/testimonial-images/37.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_5_name',
                image: require("../assets/images/testimonial-images/28.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_6_name',
                image: require("../assets/images/testimonial-images/32.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_7_name',
                image: require("../assets/images/testimonial-images/49.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_8_name',
                image: require("../assets/images/testimonial-images/47.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_9_name',
                image: require("../assets/images/testimonial-images/43.png")
            },
            {
                lang: 'fr',
                name: 'Landing_page_testimonials_10_name',
                image: require("../assets/images/testimonial-images/46.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_1_name',
                image: require("../assets/images/testimonial-images/28.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_2_name',
                image: require("../assets/images/testimonial-images/31.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_3_name',
                image: require("../assets/images/testimonial-images/28.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_4_name',
                image: require("../assets/images/testimonial-images/25.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_5_name',
                image: require("../assets/images/testimonial-images/38.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_6_name',
                image: require("../assets/images/testimonial-images/32.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_7_name',
                image: require("../assets/images/testimonial-images/39.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_8_name',
                image: require("../assets/images/testimonial-images/51.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_9_name',
                image: require("../assets/images/testimonial-images/48.png")
            },
            {
                lang: 'it',
                name: 'Landing_page_testimonials_10_name',
                image: require("../assets/images/testimonial-images/50.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_1_name',
                image: require("../assets/images/testimonial-images/34.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_2_name',
                image: require("../assets/images/testimonial-images/37.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_3_name',
                image: require("../assets/images/testimonial-images/38.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_4_name',
                image: require("../assets/images/testimonial-images/39.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_5_name',
                image: require("../assets/images/testimonial-images/42.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_6_name',
                image: require("../assets/images/testimonial-images/36.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_7_name',
                image: require("../assets/images/testimonial-images/43.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_8_name',
                image: require("../assets/images/testimonial-images/31.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_9_name',
                image: require("../assets/images/testimonial-images/44.png")
            },
            {
                lang: 'ar',
                name: 'Landing_page_testimonials_10_name',
                image: require("../assets/images/testimonial-images/50.png")
            }, {
                lang: 'de',
                name: 'Landing_page_testimonials_1_name',
                image: require("../assets/images/testimonial-images/32.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_2_name',
                image: require("../assets/images/testimonial-images/28.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_3_name',
                image: require("../assets/images/testimonial-images/25.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_4_name',
                image: require("../assets/images/testimonial-images/31.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_5_name',
                image: require("../assets/images/testimonial-images/34.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_6_name',
                image: require("../assets/images/testimonial-images/40.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_7_name',
                image: require("../assets/images/testimonial-images/49.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_8_name',
                image: require("../assets/images/testimonial-images/48.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_9_name',
                image: require("../assets/images/testimonial-images/47.png")
            },
            {
                lang: 'de',
                name: 'Landing_page_testimonials_10_name',
                image: require("../assets/images/testimonial-images/35.png")
            }, {
                lang: 'es',
                name: 'Landing_page_testimonials_1_name',
                image: require("../assets/images/testimonial-images/35.png")
            },
           {
               lang: 'es',
               name: 'Landing_page_testimonials_2_name',
               image: require("../assets/images/testimonial-images/29.png")
           },
           {
               lang: 'es',
               name: 'Landing_page_testimonials_3_name',
               image: require("../assets/images/testimonial-images/32.png")
           },{
            lang: 'es',
            name: 'Landing_page_testimonials_4_name',
            image: require("../assets/images/testimonial-images/27.png")
        },
        {
            lang: 'es',
            name: 'Landing_page_testimonials_5_name',
            image: require("../assets/images/testimonial-images/26.png")
        },
        {
            lang: 'es',
            name: 'Landing_page_testimonials_6_name',
            image: require("../assets/images/testimonial-images/39.png")
        },
        {
            lang: 'es',
            name: 'Landing_page_testimonials_7_name',
            image: require("../assets/images/testimonial-images/43.png")
        },
        {
            lang: 'es',
            name: 'Landing_page_testimonials_8_name',
            image: require("../assets/images/testimonial-images/40.png")
        },
        {
            lang: 'es',
            name: 'Landing_page_testimonials_9_name',
            image: require("../assets/images/testimonial-images/50.png")
        },
        {
            lang: 'es',
            name: 'Landing_page_testimonials_10_name',
            image: require("../assets/images/testimonial-images/31.png")
        },{
            lang: 'nl',
            name: 'Landing_page_testimonials_1_name',
            image: require("../assets/images/testimonial-images/32.png")
          },
           {
               lang: 'nl',
               name: 'Landing_page_testimonials_2_name',
               image: require("../assets/images/testimonial-images/26.png")
           },
           {
               lang: 'nl',
               name: 'Landing_page_testimonials_3_name',
               image: require("../assets/images/testimonial-images/33.png")
           }, {
            lang: 'nl',
            name: 'Landing_page_testimonials_4_name',
            image: require("../assets/images/testimonial-images/31.png")
        },
        {
            lang: 'nl',
            name: 'Landing_page_testimonials_5_name',
            image: require("../assets/images/testimonial-images/28.png")
        },
        {
            lang: 'nl',
            name: 'Landing_page_testimonials_6_name',
            image: require("../assets/images/testimonial-images/25.png")
        },
        {
            lang: 'nl',
            name: 'Landing_page_testimonials_7_name',
            image: require("../assets/images/testimonial-images/47.png")
        },
        {
            lang: 'nl',
            name: 'Landing_page_testimonials_8_name',
            image: require("../assets/images/testimonial-images/35.png")
        },
        {
            lang: 'nl',
            name: 'Landing_page_testimonials_9_name',
            image: require("../assets/images/testimonial-images/48.png")
        },
        {
            lang: 'nl',
            name: 'Landing_page_testimonials_10_name',
            image: require("../assets/images/testimonial-images/43.png")
        }, {
            lang: 'pt',
            name: 'Landing_page_testimonials_1_name',
            image: require("../assets/images/testimonial-images/31.png")
          },
           {
               lang: 'pt',
               name: 'Landing_page_testimonials_2_name',
               image: require("../assets/images/testimonial-images/34.png")
           },
           {
               lang: 'pt',
               name: 'Landing_page_testimonials_3_name',
               image: require("../assets/images/testimonial-images/27.png")
           }, {
            lang: 'pt',
            name: 'Landing_page_testimonials_4_name',
            image: require("../assets/images/testimonial-images/32.png")
        },
        {
            lang: 'pt',
            name: 'Landing_page_testimonials_5_name',
            image: require("../assets/images/testimonial-images/26.png")
        },
        {
            lang: 'pt',
            name: 'Landing_page_testimonials_6_name',
            image: require("../assets/images/testimonial-images/39.png")
        },
        {
            lang: 'pt',
            name: 'Landing_page_testimonials_7_name',
            image: require("../assets/images/testimonial-images/45.png")
        },
        {
            lang: 'pt',
            name: 'Landing_page_testimonials_8_name',
            image: require("../assets/images/testimonial-images/41.png")
        },
        {
            lang: 'pt',
            name: 'Landing_page_testimonials_9_name',
            image: require("../assets/images/testimonial-images/46.png")
        },
        {
            lang: 'pt',
            name: 'Landing_page_testimonials_10_name',
            image: require("../assets/images/testimonial-images/43.png")
        }, {
            lang: 'ru',
            name: 'Landing_page_testimonials_1_name',
            image: require("../assets/images/testimonial-images/25.png")
          },
           {
               lang: 'ru',
               name: 'Landing_page_testimonials_2_name',
               image: require("../assets/images/testimonial-images/35.png")
           },
           {
               lang: 'ru',
               name: 'Landing_page_testimonials_3_name',
               image: require("../assets/images/testimonial-images/32.png")
           },
           {
            lang: 'ru',
            name: 'Landing_page_testimonials_4_name',
            image: require("../assets/images/testimonial-images/27.png")
        },
        {
            lang: 'ru',
            name: 'Landing_page_testimonials_5_name',
            image: require("../assets/images/testimonial-images/28.png")
        },
        {
            lang: 'ru',
            name: 'Landing_page_testimonials_6_name',
            image: require("../assets/images/testimonial-images/40.png")
        },
        {
            lang: 'ru',
            name: 'Landing_page_testimonials_7_name',
            image: require("../assets/images/testimonial-images/47.png")
        },
        {
            lang: 'ru',
            name: 'Landing_page_testimonials_8_name',
            image: require("../assets/images/testimonial-images/43.png")
        },
        {
            lang: 'ru',
            name: 'Landing_page_testimonials_9_name',
            image: require("../assets/images/testimonial-images/48.png")
        },
        {
            lang: 'ru',
            name: 'Landing_page_testimonials_10_name',
            image: require("../assets/images/testimonial-images/49.png")
        },  {
                lang: 'en',
                name: 'Landing_page_testimonials_1_name',
                image: require("../assets/images/testimonial-images/28.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_2_name',
                image: require("../assets/images/testimonial-images/31.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_3_name',
                image: require("../assets/images/testimonial-images/33.png")
            },{
                lang: 'en',
                name: 'Landing_page_testimonials_4_name',
                image: require("../assets/images/testimonial-images/25.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_5_name',
                image: require("../assets/images/testimonial-images/35.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_6_name',
                image: require("../assets/images/testimonial-images/29.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_7_name',
                image: require("../assets/images/testimonial-images/41.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_8_name',
                image: require("../assets/images/testimonial-images/45.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_9_name',
                image: require("../assets/images/testimonial-images/48.png")
            },
            {
                lang: 'en',
                name: 'Landing_page_testimonials_10_name',
                image: require("../assets/images/testimonial-images/51.png")
            },
        ]
      }
    },
    methods: {
        getTestimonialImage(name) {
            return this.testimonialImages.filter(obj => obj.name === name && obj.lang === this.$i18n.locale)[0].image;
        }
    },
  };